import React, { useState, useEffect } from 'react';
import styles from '../index.css';
import { SubTitle } from '../index';

// eslint-disable-next-line react/prop-types,func-style
function TimelineH5({ content }) {
    const [url, setUrl] = useState();
    const [height, setHeight] = useState(0);

    useEffect(() => {
        // eslint-disable-next-line react/prop-types
        if (content && content.data?.length > 0) {
            // eslint-disable-next-line react/prop-types
            if (content.data[0].data?.articleList?.length > 0) {
                // eslint-disable-next-line react/prop-types
                setUrl(content.data[0].data.articleList[0].url);
            }
        }
        const b_iframe = document.getElementById('b_iframe');

        window.addEventListener(
            'message',
            e => {
                if (e?.data?.type === 'timeline/resize') {
                    console.log(e.data);
                    setHeight(e.data.value);
                }
                if (e?.data?.type === 'timeline/jump') {
                    window.location.href = e.data.value;
                }
            },
            false,
        );
        b_iframe.onload = () => {};
    }, []);

    return (
        <div>
            {
                <div>
                    <SubTitle content={content} />
                    <div className={styles.category}>
                        <iframe id="b_iframe" style={{ border: 0, width: '100%', height }} scrolling="no" src={url} />
                    </div>
                </div>
            }
        </div>
    );
}

export default TimelineH5;
